import { useContext } from 'react';

import { svgContext } from './Context';

const useSvgContext = () => {
  const context = useContext(svgContext);
  if (!context) {
    throw new Error('useSvg must be used within a SvgProvider');
  }
  return context;
};

export default useSvgContext;
